import {Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ContactUsService} from "../../../shared/services/contact-us.service";
import {AlertService} from "../../../shared/services/alert.service";
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-server-migration-monitoring',
    templateUrl: './server-migration-monitoring.component.html',
    styleUrls: ['./server-migration-monitoring.component.scss']
})
export class ServerMigrationMonitoringComponent implements OnInit {

    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;
    service1 = [
        {text: 'AWS'},
        {text: 'GCP'},
        {text: 'Azure'},
    ];
    service2 = [
        {text: 'E-mail systems'},
        {text: 'Cloud Migration ( P2V, V2V )'},
        {text: 'Data center migration to Co-Lo or Cloud'},
        {text: 'Installation of new IT systems on large, medium or small scale'},
    ];
    service3 = [
        {text: 'Network Monitoring'},
        {text: 'Service Monitoring'},
        {text: 'Endpoint Monitoring'},
    ];
    modules = [
        {text: 'Admissions Management'},
        {text: 'Attendance Management'},
        {text: 'Fees Management'},
        {text: 'Exams Management'},
        {text: 'Library Management'},
        {text: 'Payroll Management'},
        {text: 'Organized Department'},
        {text: 'Record Management'},
    ];
    selectedIndex= 0
    tabs = [
        {
            title: 'Streamline Your Operations',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/consult.png',
                detail:'By eliminating the need for servers, we offer serverless computing solutions that help to manage the platform, letting your developers focus on other more essential tasks with Amazon Web Services (AWS), Google Cloud Platform (GCP), and Microsoft Azure. Each and every platform has its unique features and benefits, ensuring business productivity.',
                list:[
                    `  Amazon Web Services (AWS): AWS offers serverless solutions like AWS Lambda, enabling code execution without server management. Services include Amazon S3 for storage, DynamoDB for databases, and API Gateway for APIs.`,
                    ' Google Cloud Platform (GCP): GCP serverless architecture simplifies app development by automating scaling with Cloud Functions for event-driven tasks and Cloud Run for containerized apps, offering cost-efficiency and data-driven insights.',
                    ' Microsoft Azure: Azure serverless monitoring services execute code on triggers like HTTP, automate workflows, integrate apps, and support multiple languages, offering scalability and flexibility for building robust, high-performance applications.'
                ]
            },
        },
        {
            title: 'Comprehensive Migration and Integration Services',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/info.png',
                detail:'Experience our migration and integration services for seamless transactions of your business operations to modern infrastructure. At Volmint, we develop, deploy, and deliver E-mail Systems Migration, Data Center Migration, New IT Systems Installation, and Cloud Migration (P2V, V2V) like services with minimal disruptions and maximum efficiency.\n',
                list:[
                    ' E-mail Systems Migration: Our E-mail Systems Migration service assists organizations in transitioning from legacy systems to modern cloud-based platforms like Microsoft 365 or Google Workspace, ensuring zero data loss, continuity, minimal downtime, and enhanced collaboration and productivity.',
                    'Data Center Migration: Data Center Migration services help businesses relocate their on-premises data centers to colocation or cloud environments. We develop customized migration strategies, manage the process, ensure reducing risks, and improve scalability.',
                    'New IT Systems Installation: Installation of New IT Systems service offers comprehensive solutions for organizations of all sizes, ensuring a smooth installation process that aligns with business requirements, optimizes performance, and minimizes downtime, ensuring optimal efficiency.',
                    ' Cloud Migration (P2V, V2V): Cloud Migration services offer both P2V and V2V migrations, converting physical servers into virtual machines for cloud environments and optimizing resource utilization and performance, ensuring data integrity and performance optimization.'
                ]
            },
        },
        {
            title: 'Holistic Monitoring Services To Enhance Performance',
            content: {
                img: 'assets/img/landing-new/db-devops-serverless/business.png',
                detail:'Enhance the performance of your technological infrastructure with our comprehensive monitoring services, stay in control of your IT environment, enabling you to respond swiftly to potential issues while optimizing operational efficiency. We focus on three critical areas—network, service, and endpoint monitoring\n',
                list:[
                    'Network Monitoring: The Network Monitoring service provides organizations with real-time alerts and detailed reporting on network performance, security, and device health, enabling them to identify bottlenecks, optimize performance, and enhance network reliability.',
                    'Service Monitoring: Service Monitoring focuses on tracking critical applications, assessing response times, error rates, and user experience. It detects issues early, enables swift remediation, and provides insights into usage patterns, enabling informed decision-making for future improvements.',
                    'Endpoint Monitoring: Endpoint Monitoring service offers comprehensive control over all endpoints within your organization, ensuring security, compliance, and software updates. This proactive approach detects potential vulnerabilities, responds to threats, and provides business efficiency.'
                ]
            },
        },
    ];
    features = [
        {icon: 'assets/img/landing-new/argus/monitoring.png', text: 'Server Setup and Configuration'},
        {icon: 'assets/img/landing-new/argus/analytics.png', text: 'Performance Monitoring'},
        {icon: 'assets/img/landing-new/argus/custom.png', text: 'Security Management'},
        {icon: 'assets/img/landing-new/argus/user.png', text: 'Backup and Disaster Recovery'},
        {icon: 'assets/img/landing-new/argus/multi.png', text: 'Updates and Patch Management'},
        {icon: 'assets/img/landing-new/argus/hybrid.png', text: 'Load Balancing'},
        {icon: 'assets/img/landing-new/argus/automated.png', text: 'Scalability'},
        {icon: 'assets/img/landing-new/argus/scalability.png', text: 'Remote Management'},
        {icon: 'assets/img/services/ongoing_support.jpeg', text: 'Resource Allocation'}

    ];
    whyChoose1 = [
        {
            icon : 'fa-solid fa-gears',
            header: 'Tailored IT Strategies for Every Business',
            text: 'We analyze your business requirements and design customized IT solutions that align perfectly with your organizational goals, ensure optimal security and growth with ease of technology.'
        },
        {
            icon: 'fa-solid fa-hand-holding-dollar',
            header: 'Cost-Efficiency Without Compromising Quality',
            text: 'We collaborate with your team and guide them in using cost-effective resources that provide appropriate support to your infrastructure without compromising the quality.'
        },
        {
            icon : 'fa-solid fa-infinity',
            header: 'End-to-End Support',
            text: 'Our focus is to provide the best support that drives business excellence by implementing the latest techniques and tools. From consulting to monitoring, we offer robust support to work smoothly and effectively.'
        },
        {
            icon : 'fa-solid fa-cloud',
            header : 'Future-Ready IT Infrastructure',
            text : 'Our team is equipped with the newest techniques and innovations that allow us to focus on security and scalability. We ensure business adaptability with changing demands and future challenges.'
        }
    ];
    benifits = [
        {
            header: 'Boost Developer VelocitY',
            text: 'Decrease the time spent on non-essential business chores by freeing developers with delegate provisioning and management. We encourage ready-to-use machine learning, cognitive models, and low-code/no-code services, developer-friendly APIs to build and deploy more quickly.'
        },
        {
            header: 'Improve Team Performance',
            text: 'With our Serverless Computing Services, businesses can build, deploy, and run the apps on a fully managed platform that improves team performance and agility. We analyze apps proactively and the latest use technologies for intelligent monitoring, including application patterns, edge, cloud, and hybrid.'
        },
        {
            header: 'Enhance Organizational Impact ',
            text: 'Serverless computing in Azure can help your company speed up time to market by paving the way for innovation and new income streams. Use advanced threat prevention and intelligent security management to lower the total cost of ownership of your infrastructure and reduce risk.'
        },
        {
            header: 'Customized Solutions',
            text: 'We have a team of experts who understand your business requirements carefully and design solutions that perfectly align with your business goals. Our serverless monitoring architecture allows your IT system to grow effortlessly and provide unmatched flexibility.'
        }
    ];
    offerings = [
        {
            text: 'Holistic Approach'
        },
        {
            text: 'Modular Flexibility'
        },
        {
            text: 'Real-Time Insights'
        },
        {
            text: 'Enhanced Security'
        },
        {
            text: 'Scalability and Adaptability'
        },
    ];

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private contactService: ContactUsService,
        private alertService: AlertService,
        private meta: Meta,
        private title: Title
    ) {
    }

    ngOnInit(): void {
        this.updateMetaTags()
        this.refresh();
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            subject: ['', Validators.required],
            message: ['', Validators.required]
        });
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }

    selectTab(index: number) {
        this.selectedIndex = index;
    }
    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                'subject': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().subject) ? this.contactForm.getRawValue().subject : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'subject': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].subject[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const scrollPosition = window.innerHeight + window.scrollY;

        elements.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            if (scrollPosition >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });

        const elements1 = document.querySelectorAll('.animate-on-scroll-right');
        const scrollPosition1 = window.innerHeight + window.scrollY;
        elements1.forEach((element) => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;

            if (scrollPosition1 >= elementPosition) {
                element.classList.add('visible'); // Add the visible class when in view
            }
        });
    }



    updateMetaTags() {
        this.title.setTitle('Serverless Computing & Cloud Integration | Scalable & Secure Solutions');
        this.meta.updateTag({
            name: 'description',
            content: 'Enhance performance, reduce cost, and save time with Volmint’s end-to-end serverless computing and cloud migration services, optimizing efficiency and enhancing scalability.'

        });
        this.meta.updateTag({
            name: 'keyword',
            content: 'serverless computing, cloud migration services, serverless monitoring, serverless architecture on aws, serverless computing and integration services, serverless computing in azure, cloud migration as a service, cloud migration company, serverless computing services, azure serverless monitoring'

        });
    }

}
